// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "span.registeredTrademark[data-v-7ba5bd90] {\n  position: relative;\n  top: -0.3rem;\n  font-size: 0.5rem;\n  left: -0.05rem;\n}\nfooter[data-v-7ba5bd90] {\n  font-size: small;\n}", ""]);
// Exports
module.exports = exports;
